/** Verrouillage de session après inactivité. */
export class SessionIdleService {
  static readonly IDLE_MS = 8 * 60 * 60 * 1000; // A-34 : 8 h (doc sécurité)

  private timer: ReturnType<typeof setTimeout> | null = null;
  private readonly events = [
    'mousemove',
    'mousedown',
    'keydown',
    'touchstart',
    'scroll',
    'input',
  ] as const;
  private readonly onActivity: () => void;
  private lastTouchAt = 0;

  constructor(
    private readonly onIdle: () => void,
    private readonly onTouch?: () => void,
  ) {
    this.onActivity = () => {
      this.resetTimer();
      // Limite les écritures stockage (max 1× / 30 s)
      const now = Date.now();
      if (this.onTouch && now - this.lastTouchAt > 30_000) {
        this.lastTouchAt = now;
        this.onTouch();
      }
    };
  }

  start(): void {
    this.stop();
    for (const ev of this.events) {
      document.addEventListener(ev, this.onActivity, { passive: true });
    }
    this.resetTimer();
  }

  stop(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    for (const ev of this.events) {
      document.removeEventListener(ev, this.onActivity);
    }
  }

  private resetTimer(): void {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.onIdle(), SessionIdleService.IDLE_MS);
  }
}
